import React, { useEffect, useRef, useState } from "react"
import {
  Button,
  Col,
  DatePicker,
  Form,
  Input,
  message,
  Modal,
  notification,
  Row,
  Select,
  Space,
  Table,
} from "antd"
import { unwrapResult } from "@reduxjs/toolkit"
import layout from "antd/lib/layout"
import { useDispatch, useSelector } from "react-redux"
import { RootDispatch } from "../../../app/store"
import { DateSelect } from "../../../compnents/form/DateSelect"
import { CloseOutlined, PlusOutlined, SearchOutlined } from "@ant-design/icons"
import { stringTrim } from "../../../utils/StringUtils"
import FileUpload from "../../../compnents/file/FileUpload"
import Upload, { RcFile } from "antd/lib/upload"
import { UploadFile } from "antd/lib/upload/interface"
import styles from "../filing.module.css"
import axios from "axios"
import {
  selectCredentials,
  selectTenantName,
} from "../../../app/applicationSlice"
import { selectTenant } from "../../user/setting/settingSlice"
import moment from "moment"
import {
  DateTimeFormatSimple,
  DateTimeFormatSimpleOnly,
} from "../../../models/datetime"
import {
  acceptImgTypes,
  AXIOS_IP,
  beforeUpload,
  beforeUploadFile,
  beforeUploadFileAndImage,
  customRequest,
  generateTempId,
  mapType,
} from "../fileUploadService"
import { PreviewImgOrPdf } from "../Preview"
import { EditableList } from "../../../compnents/list/EditableList"
import { validateRequiredFields } from "../AntimicrobialDrugs/validate"
import {
  CTYXEngagedColumns,
  CTYXStudyColumns,
  CTYXWorkColumns,
} from "../columns"

export const CTYXFFormModal = (props: {
  visible: boolean
  token: string
  filingType: number
  againId?: string
  memo?: string
  onOk: () => void
  onCancel: () => void
}) => {
  const { Option } = Select

  const { TextArea } = Input

  const { RangePicker } = DatePicker

  const dispatch = useDispatch<RootDispatch>()

  const credentials: any = useSelector(selectCredentials)

  const tenantName = useSelector(selectTenantName)

  const tenant = useSelector(selectTenant)

  const inputRef = useRef<any>(null)
  const scrollDivRef = useRef<any>(null)

  const [formStepFirst] = Form.useForm()
  const [formStepSecond] = Form.useForm()
  const [formStepThird] = Form.useForm()

  const [submitVisible, setSubmitVisible] = useState(false)

  const [confirmLoading, setConfirmLoading] = useState(false)

  const [baseUrl, setBaseUrl] = useState("")

  const [baseType, setBaseType] = useState(true)

  const [previewFile, setPreviewFile] = useState<any>() //预览

  const [step, setStep] = useState(1)

  const [XXData, setXXData] = useState<any[]>([]) //学习
  const [GZData, setGZData] = useState<any[]>([]) //工作
  const [CSData, setCSData] = useState<any[]>([]) //从事

  const [fileYCUrl, setfileYCUrl] = useState<any>([]) //一寸照
  const [fileZMUrl, setfileZMUrl] = useState<any>([]) //正面
  const [fileFMUrl, setfileFMUrl] = useState<any>([]) //反面
  const [fileBYUrl, setfileBYUrl] = useState<any>([]) //毕业证
  const [fileZGUrl, setfileZGUrl] = useState<any>([]) //资格证书
  const [fileZYUrl, setfileZYUrl] = useState<any>([]) //执业证书
  const [fileFGUrl, setfileFGUrl] = useState<any>([]) //副高职称
  const [fileHTUrl, setfileHTUrl] = useState<any>([]) //合同
  const [fileSJUrl, setfileSJUrl] = useState<any>([]) //临床实践
  const [fileGZUrl, setfileGZUrl] = useState<any>([]) //公证书

  const [stepFirstData, setStepFirstData] = useState<any>({})
  const [stepSecondData, setStepSecondData] = useState<any>({})
  const [stepThirdData, setStepThirdData] = useState<any>({})

  const [types, setTypes] = useState<any>({})

  //参考模板
  const templateData = {
    fileConfigId: "5",
    fileName: "参考模板",
    fileType: "application/pdf",
    filePath:
      "68e0cfd54adf77575a83a2b739bf5ddfa207356d866e9e74b8236c4b070475f8",
  }

  const XXRequiredList = [
    { name: "开始日期", key: "startTime", required: true },
    { name: "结束日期", key: "endTime", required: true },
    { name: "学校", key: "school", required: true },
    // { name: "专业", key: "professional", required: true },
    { name: "毕（结、肄）业", key: "graduationStatus", required: true },
  ]

  const GZRequiredList = [
    { name: "开始日期", key: "studyStartDate", required: true },
    { name: "结束日期", key: "studyEndDate", required: true },
    { name: "单位", key: "unit", required: true },
    { name: "职位", key: "position", required: true },
  ]

  const CSRequiredList = [
    { name: "开始日期", key: "studyStartDate", required: true },
    { name: "结束日期", key: "studyEndDate", required: true },
    { name: "单位", key: "unit", required: true },
    { name: "科室", key: "department", required: true },
    { name: "职位/职称", key: "position", required: true },
  ]

  const getTypes = () => {
    axios({
      url: `${AXIOS_IP}/dic/getDicListByDicTypes`,
      headers: {
        "Content-Type": "application/json",
        "His-Auth": props.token,
      },
      withCredentials: false,
      method: "POST",
      data: {
        dicTypeList: [
          "system_user_sex", //性别
          "id_card_type", // 证件类型
          "education_level", // 学历
          "degree_type", // 学位
          "graduation_status", // 毕业状态
          "ethnic_group", // 民族
          "assessment_status", // 考核情况
        ],
      },
    }).then((res: any) => {
      const data: any = res.data.data
      setTypes({
        systemUserSex: mapType(data?.system_user_sex),
        idCardType: mapType(data?.id_card_type),
        educationLevel: mapType(data?.education_level),
        degreeType: mapType(data?.degree_type),
        graduationStatus: mapType(data?.graduation_status),
        ethnicGroup: mapType(data?.ethnic_group),
        assessmentStatus: mapType(data?.assessment_status),
      })
    }).catch((err) => { console.error(err) })
  }

  // 自定义上传实现
  const customRequestFn = (options: any, type: string) => {
    customRequest(options, AXIOS_IP, (data: any) => {
      const newurl = {
        fileConfigId: data?.configId,
        fileName: data?.name,
        fileType: data?.type,
        filePath: data?.path,
      }
      switch (type) {
        case "YC":
          setfileYCUrl([...fileYCUrl, newurl])
          break
        case "ZM":
          setfileZMUrl([...fileZMUrl, newurl])
          break
        case "FM":
          setfileFMUrl([...fileFMUrl, newurl])
          break
        case "BY":
          setfileBYUrl([...fileBYUrl, newurl])
          break
        case "ZG":
          setfileZGUrl([...fileZGUrl, newurl])
          break
        case "ZY":
          setfileZYUrl([...fileZYUrl, newurl])
          break
        case "FG":
          setfileFGUrl([...fileFGUrl, newurl])
          break
        case "HT":
          setfileHTUrl([...fileHTUrl, newurl])
          break
        case "SJ":
          setfileSJUrl([...fileSJUrl, newurl])
          break
        case "GZ":
          setfileGZUrl([...fileGZUrl, newurl])
          break
      }
    })
  }

  const handleRemove = (type: string, index: number) => {
    switch (type) {
      case "YC":
        setfileYCUrl(fileYCUrl?.filter((v: any, i: number) => i !== index))
        break
      case "ZM":
        setfileZMUrl(fileZMUrl?.filter((v: any, i: number) => i !== index))
        break
      case "FM":
        setfileFMUrl(fileFMUrl?.filter((v: any, i: number) => i !== index))
        break
      case "BY":
        setfileBYUrl(fileBYUrl?.filter((v: any, i: number) => i !== index))
        break
      case "ZG":
        setfileZGUrl(fileZGUrl?.filter((v: any, i: number) => i !== index))
        break
      case "ZY":
        setfileZYUrl(fileZYUrl?.filter((v: any, i: number) => i !== index))
        break
      case "FG":
        setfileFGUrl(fileFGUrl?.filter((v: any, i: number) => i !== index))
        break
      case "HT":
        setfileHTUrl(fileHTUrl?.filter((v: any, i: number) => i !== index))
        break
      case "SJ":
        setfileSJUrl(fileSJUrl?.filter((v: any, i: number) => i !== index))
        break
      case "GZ":
        setfileGZUrl(fileGZUrl?.filter((v: any, i: number) => i !== index))
        break
    }
  }

  useEffect(() => {
    formStepFirst.setFieldsValue({
      oneInchPhotoFile: fileYCUrl,
    })
  }, [fileYCUrl])

  useEffect(() => {
    formStepFirst.setFieldsValue({
      idCardPositiveFile: fileZMUrl,
    })
  }, [fileZMUrl])

  useEffect(() => {
    formStepFirst.setFieldsValue({
      idCardOppositeFile: fileFMUrl,
    })
  }, [fileFMUrl])

  useEffect(() => {
    formStepFirst.setFieldsValue({
      graduationCertificateFile: fileBYUrl,
    })
  }, [fileBYUrl])

  useEffect(() => {
    formStepSecond.setFieldsValue({
      practiceCertificateFile: fileZYUrl,
    })
  }, [fileZYUrl])

  useEffect(() => {
    formStepSecond.setFieldsValue({
      qualificationCertificateFile: fileZGUrl,
    })
  }, [fileZGUrl])

  useEffect(() => {
    formStepSecond.setFieldsValue({
      advancedCertificateFile: fileFGUrl,
    })
  }, [fileFGUrl])

  // useEffect(() => {
  //   formStepThird.setFieldsValue({
  //     masterApprenticeContractFile: fileHTUrl,
  //   })
  // }, [fileHTUrl])

  useEffect(() => {
    formStepThird.setFieldsValue({
      clinicalPracticeFile: fileSJUrl,
    })
  }, [fileSJUrl])

  useEffect(() => {
    formStepThird.setFieldsValue({
      notarizedCertificateFile: fileGZUrl,
    })
  }, [fileGZUrl])

  useEffect(() => {
    if (!props.visible) {
      formStepFirst.resetFields()
      formStepSecond.resetFields()
      formStepThird.resetFields()
      setfileZMUrl([])
      setfileFMUrl([])
      setfileYCUrl([])
      setfileBYUrl([])
      setfileZYUrl([])
      setfileZGUrl([])
      setfileFGUrl([])
      setfileHTUrl([])
      setfileGZUrl([])
      setfileSJUrl([])
      setXXData([])
      setGZData([])
      setCSData([])
      setStep(1)
      setStepFirstData({})
      setStepSecondData({})
      setStepThirdData({})
    } else {
      getTypes()
      if (props.againId) {
        axios({
          url: `${AXIOS_IP}/filingReviewMentor/detail`,
          headers: {
            "Content-Type": "application/json",
            "His-Auth": props.token,
          },
          withCredentials: false,
          method: "POST",
          data: { id: props.againId, filingType: props.filingType, },
        }).then((res) => {
          if (res.data.data) {
            const data = res.data.data
            formStepFirst.setFieldsValue({
              ...data?.filingApplicantPersonVO,
              birthDate: moment(data?.filingApplicantPersonVO?.birthDate),
            })
            formStepSecond.setFieldsValue(data?.filingGuidanceTeacherVO)
            formStepThird.setFieldsValue({
              ...data?.filingFollowLearningVO,
              contractNotarizationDate: moment(data?.filingFollowLearningVO?.contractNotarizationDate),
              learningDate: [moment(data?.filingApplicantPersonVO?.learningStartDate), moment(data?.filingApplicantPersonVO?.learningEndDate)]
            })
            setStepFirstData(data?.filingApplicantPersonVO)
            setStepSecondData(data?.filingGuidanceTeacherVO)
            setStepThirdData(data?.filingFollowLearningVO)
            setXXData(
              data?.filingApplicantPersonVO?.filingStudyExperienceVOList?.map((v: any) => {
                return {
                  ...v,
                  startTime: moment(v?.startTime),
                  endTime: moment(v?.endTime),
                }
              })?.concat(
                [{ id: generateTempId() }]
              ) || [{ id: generateTempId() }]
            )
            setGZData(
              data?.filingApplicantPersonVO?.filingWorkExperienceVOList?.map((v: any) => {
                return {
                  ...v,
                  studyStartDate: moment(v?.studyStartDate),
                  studyEndDate: moment(v?.studyEndDate),
                }
              })?.concat(
                [{ id: generateTempId() }]
              ) || [{ id: generateTempId() }]
            )
            setCSData(
              data?.filingGuidanceTeacherVO?.filingWorkExperienceVOList?.map((v: any) => {
                return {
                  ...v,
                  studyStartDate: moment(v?.studyStartDate),
                  studyEndDate: moment(v?.studyEndDate),
                }
              })?.concat(
                [{ id: generateTempId() }]
              ) || [{ id: generateTempId() }]
            )
            setfileZMUrl(
              data?.filingApplicantPersonVO?.idCardPositiveFile || []
            )
            setfileFMUrl(
              data?.filingApplicantPersonVO?.idCardOppositeFile || []
            )
            setfileYCUrl(data?.filingApplicantPersonVO?.oneInchPhotoFile || [])
            setfileBYUrl(
              data?.filingApplicantPersonVO?.graduationCertificateFile || []
            )
            setfileZYUrl(
              data?.filingGuidanceTeacherVO?.practiceCertificateFile || []
            )
            setfileZGUrl(
              data?.filingGuidanceTeacherVO?.qualificationCertificateFile || []
            )
            setfileFGUrl(
              data?.filingGuidanceTeacherVO?.advancedCertificateFile || []
            )
            // setfileHTUrl(
            //   data?.filingFollowLearningVO?.masterApprenticeContractFile || []
            // )
            setfileSJUrl(
              data?.filingFollowLearningVO?.clinicalPracticeFile || []
            )
            setfileGZUrl(
              data?.filingFollowLearningVO?.notarizedCertificateFile || []
            )
          }
        }).catch((err) => { console.error(err) })
      } else {
        if (!XXData.length) {
          setXXData([{ id: generateTempId() }])
        }
        if (!GZData.length) {
          setGZData([{ id: generateTempId() }])
        }
        if (!CSData.length) {
          setCSData([{ id: generateTempId() }])
        }
        setTimeout(() => {
          if(inputRef?.current) {
            inputRef.current.focus?.()
          }
        }, 100)
      }
    }
  }, [props.visible])

  return (
    <>
      <Modal
        title={props.filingType == 5 ? '传统医学传承管理' : '中医医术确有专长医师管理'}
        width={1000}
        visible={props?.visible}
        centered
        onCancel={() => {
          props?.onCancel()
        }}
        maskClosable={false}
        footer={null}
      >
        <div ref={scrollDivRef} style={{ height: 600, overflow: 'auto', paddingRight: 10 }}>
          <Form
            form={formStepFirst}
            labelCol={{ span: 8 }}
            wrapperCol={{ span: 16 }}
            style={{ paddingRight: 10 }}
            onFinish={(vs) => {
              if (XXData?.length <= 1) {
                notification.error({
                  message: "请填写学习经历",
                  duration: 3,
                })
                return
              }
              if (GZData?.length <= 1) {
                notification.error({
                  message: "请填写工作经历",
                  duration: 3,
                })
                return
              }
              setStepFirstData(vs)
              setStep(step + 1)
              if (scrollDivRef.current) {
                scrollDivRef.current.scrollTop = 0
              }
            }}
          >
            {step === 2 && (
              <>
                <Row style={{ fontSize: 17, fontWeight: "bold" }}>
                  申报人基本信息
                </Row>
                <Row
                  style={{
                    fontSize: 14,
                    fontWeight: "bold",
                    marginTop: 15,
                    marginBottom: 10,
                  }}
                >
                  人员基本信息
                </Row>
                <Row>
                  <Col span={12}>
                    <Form.Item
                      name="name"
                      label="姓名"
                      rules={[{ required: true }]}
                    >
                      <Input ref={inputRef} allowClear />
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item
                      name="sex"
                      label="性别"
                      rules={[{ required: true }]}
                    >
                      <Select allowClear>
                        {types.systemUserSex?.map((v: any) => {
                          return (
                            <Option key={v.value} value={v.value}>
                              {v.label}
                            </Option>
                          )
                        })}
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item
                      name="cardType"
                      label="证件类型"
                      rules={[{ required: true }]}
                    >
                      <Select allowClear>
                        {types.idCardType?.map((v: any) => {
                          return (
                            <Option key={v.value} value={v.value}>
                              {v.label}
                            </Option>
                          )
                        })}
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item
                      name="cardNumber"
                      label="证件号码"
                      rules={[{ required: true }]}
                    >
                      <Input allowClear />
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item name="birthDate" label="出生日期" rules={[{ required: true }]}>
                      <DatePicker
                        style={{ width: "100%" }}
                        format={DateTimeFormatSimpleOnly}
                        allowClear
                      />
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item name="nativePlace" label="籍贯">
                      <Input allowClear />
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item
                      name="education"
                      label="学历"
                      rules={[{ required: true }]}
                    >
                      <Select allowClear>
                        {types.educationLevel?.map((v: any) => {
                          return (
                            <Option key={v.value} value={v.value}>
                              {v.label}
                            </Option>
                          )
                        })}
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item
                      name="degree"
                      label="学位"
                      rules={[{ required: true }]}
                    >
                      <Select allowClear>
                        {types.degreeType?.map((v: any) => {
                          return (
                            <Option key={v.value} value={v.value}>
                              {v.label}
                            </Option>
                          )
                        })}
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item
                      name="ethnicGroup"
                      label="民族"
                      rules={[{ required: true }]}
                    >
                      <Select
                        showSearch
                        filterOption={(input, option: any) =>
                          (option?.children ?? "")
                            .toLowerCase()
                            ?.includes(input.toLowerCase())
                        }
                        allowClear
                      >
                        {types.ethnicGroup?.map((v: any) => {
                          return (
                            <Option key={v.value} value={v.value}>
                              {v.label}
                            </Option>
                          )
                        })}
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item
                      name="unitName"
                      label="单位名称"
                      rules={[{ required: true }]}
                    >
                      <Input allowClear />
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item
                      name="address"
                      label="通讯地址"
                      rules={[{ required: true }]}
                    >
                      <Input allowClear />
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item
                      name="postCode"
                      label="邮政编码"
                      rules={[{ required: true }]}
                    >
                      <Input allowClear />
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item
                      name="mainOccupation"
                      label="现从事主要职业"
                      rules={[{ required: true }]}
                    >
                      <Input allowClear />
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item
                      name="contactInformation"
                      label="联系方式"
                      rules={[{ required: true }]}
                    >
                      <Input allowClear />
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item
                      name="registrationArea"
                      label="报考区域"
                      rules={[{ required: true }]}
                    >
                      <Input allowClear />
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item
                      labelCol={{ span: 8 }}
                      wrapperCol={{ span: 16 }}
                      name="oneInchPhotoFile"
                      label="一寸照"
                      rules={[{ required: true, message: "请上传一寸照" }]}
                    >
                      <Row align="middle">
                        <>
                          <Upload
                            customRequest={(options) =>
                              customRequestFn(options, "YC")
                            }
                            beforeUpload={(file) =>
                              beforeUpload(file, fileYCUrl)
                            }
                            showUploadList={false}
                            maxCount={3}
                            accept={acceptImgTypes}
                          >
                            <Button icon={<PlusOutlined />}>上传</Button>
                          </Upload>
                        </>
                        {fileYCUrl?.length > 0 &&
                          fileYCUrl?.map((v: any, index: number) => {
                            return (
                              <div
                                key={index}
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  cursor: "pointer",
                                  paddingLeft: 10,
                                }}
                              >
                                <span style={{ paddingRight: 10 }}>
                                  {v.fileName}{" "}
                                  <a
                                    style={{ paddingLeft: 10 }}
                                    onClick={() => setPreviewFile(v)}
                                  >
                                    查看
                                  </a>
                                </span>
                                <CloseOutlined
                                  style={{
                                    position: "relative",
                                    top: 2,
                                    color: "rgb(161 161 161)",
                                  }}
                                  onClick={() => {
                                    handleRemove("YC", index)
                                  }}
                                />
                              </div>
                            )
                          })}
                      </Row>
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item
                      labelCol={{ span: 8 }}
                      wrapperCol={{ span: 16 }}
                      name="idCardPositiveFile"
                      label="身份证正面照片"
                      rules={[{ required: true, message: "请上传身份证正面照片" }]}
                    >
                      <Row align="middle">
                        <>
                          <Upload
                            customRequest={(options) =>
                              customRequestFn(options, "ZM")
                            }
                            beforeUpload={(file) =>
                              beforeUpload(file, fileZMUrl)
                            }
                            showUploadList={false}
                            maxCount={3}
                            accept={acceptImgTypes}
                          >
                            <Button icon={<PlusOutlined />}>上传</Button>
                          </Upload>
                        </>
                        {fileZMUrl?.length > 0 &&
                          fileZMUrl?.map((v: any, index: number) => {
                            return (
                              <div
                                key={index}
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  cursor: "pointer",
                                  paddingLeft: 10,
                                }}
                              >
                                <span style={{ paddingRight: 10 }}>
                                  {v.fileName}{" "}
                                  <a
                                    style={{ paddingLeft: 10 }}
                                    onClick={() => setPreviewFile(v)}
                                  >
                                    查看
                                  </a>
                                </span>
                                <CloseOutlined
                                  style={{
                                    position: "relative",
                                    top: 2,
                                    color: "rgb(161 161 161)",
                                  }}
                                  onClick={() => {
                                    handleRemove("ZM", index)
                                  }}
                                />
                              </div>
                            )
                          })}
                      </Row>
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item
                      labelCol={{ span: 8 }}
                      wrapperCol={{ span: 16 }}
                      name="idCardOppositeFile"
                      label="身份证反面照片"
                      rules={[{ required: true, message: "请上传身份证反面照片" }]}
                    >
                      <Row align="middle">
                        <>
                          <Upload
                            customRequest={(options) =>
                              customRequestFn(options, "FM")
                            }
                            beforeUpload={(file) =>
                              beforeUpload(file, fileFMUrl)
                            }
                            showUploadList={false}
                            maxCount={3}
                            accept={acceptImgTypes}
                          >
                            <Button icon={<PlusOutlined />}>上传</Button>
                          </Upload>
                        </>
                        {fileFMUrl?.length > 0 &&
                          fileFMUrl?.map((v: any, index: number) => {
                            return (
                              <div
                                key={index}
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  cursor: "pointer",
                                  paddingLeft: 10,
                                }}
                              >
                                <span style={{ paddingRight: 10 }}>
                                  {v.fileName}{" "}
                                  <a
                                    style={{ paddingLeft: 10 }}
                                    onClick={() => setPreviewFile(v)}
                                  >
                                    查看
                                  </a>
                                </span>
                                <CloseOutlined
                                  style={{
                                    position: "relative",
                                    top: 2,
                                    color: "rgb(161 161 161)",
                                  }}
                                  onClick={() => {
                                    handleRemove("FM", index)
                                  }}
                                />
                              </div>
                            )
                          })}
                      </Row>
                    </Form.Item>
                  </Col>
                  <Col span={24}>
                    <Form.Item
                      labelCol={{ span: 4 }}
                      wrapperCol={{ span: 20 }}
                      name="graduationCertificateFile"
                      label="毕业证书"
                      rules={[{ required: true, message: "请上传毕业证书" }]}
                    >
                      <Row align="middle">
                        <>
                          <Upload
                            customRequest={(options) =>
                              customRequestFn(options, "BY")
                            }
                            beforeUpload={(file) =>
                              beforeUpload(file, fileBYUrl)
                            }
                            showUploadList={false}
                            maxCount={3}
                            accept={acceptImgTypes}
                          >
                            <Button icon={<PlusOutlined />}>上传</Button>
                          </Upload>
                        </>
                        {fileBYUrl?.length > 0 &&
                          fileBYUrl?.map((v: any, index: number) => {
                            return (
                              <div
                                key={index}
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  cursor: "pointer",
                                  paddingLeft: 10,
                                }}
                              >
                                <span style={{ paddingRight: 10 }}>
                                  {v.fileName}{" "}
                                  <a
                                    style={{ paddingLeft: 10 }}
                                    onClick={() => setPreviewFile(v)}
                                  >
                                    查看
                                  </a>
                                </span>
                                <CloseOutlined
                                  style={{
                                    position: "relative",
                                    top: 2,
                                    color: "rgb(161 161 161)",
                                  }}
                                  onClick={() => {
                                    handleRemove("BY", index)
                                  }}
                                />
                              </div>
                            )
                          })}
                      </Row>
                    </Form.Item>
                  </Col>
                </Row>
                <Row
                  style={{
                    fontSize: 14,
                    fontWeight: "bold",
                    marginTop: 15,
                    marginBottom: 10,
                  }}
                >
                  学习经历
                </Row>
                <EditableList
                  style={{ marginTop: "15px" }}
                  scroll={{ x: "30rem" }}
                  dataSource={XXData}
                  pagination={false}
                  rowKey={(m: any) => m.id}
                  columns={CTYXStudyColumns(
                    AXIOS_IP,
                    props.token,
                    types.graduationStatus,
                    (text, t) => {
                      if (text == "edit") {
                        const result = validateRequiredFields(t, XXRequiredList)
                        const flag =
                          XXData.findIndex((d) => d.id === t.id) ===
                          XXData.length - 1
                        const newData = XXData.map((item: any) => {
                          if (item.id == t.id) {
                            return t
                          } else {
                            return item
                          }
                        })

                        setXXData(
                          result
                            ? newData
                            : flag //判断是否为最新一行，是的就添加一行
                            ? newData.concat([{ id: generateTempId() }])
                            : newData
                        )
                      } else if (text == "remove") {
                        const flag =
                          XXData.findIndex((d) => d.id === t.id) ===
                          XXData.length - 1
                        if (flag) {
                          setXXData(
                            XXData.map((item: any) => {
                              if (item.id == t.id) {
                                return { id: generateTempId() }
                              } else {
                                return item
                              }
                            })
                          )
                        } else {
                          setXXData(
                            XXData.filter((item: any) => item.id != t.id)
                          )
                        }
                      }
                    }
                  )}
                  sticky
                />
                <Row
                  style={{
                    fontSize: 14,
                    fontWeight: "bold",
                    marginTop: 15,
                    marginBottom: 10,
                  }}
                >
                  工作经历
                </Row>
                <EditableList
                  style={{ marginTop: "15px" }}
                  scroll={{ x: "30rem" }}
                  dataSource={GZData}
                  pagination={false}
                  rowKey={(m: any) => m.id}
                  columns={CTYXWorkColumns((text, t) => {
                    if (text == "edit") {
                      const result = validateRequiredFields(t, GZRequiredList)
                      const flag =
                        GZData.findIndex((d) => d.id === t.id) ===
                        GZData.length - 1
                      const newData = GZData.map((item: any) => {
                        if (item.id == t.id) {
                          return t
                        } else {
                          return item
                        }
                      })

                      setGZData(
                        result
                          ? newData
                          : flag //判断是否为最新一行，是的就添加一行
                          ? newData.concat([{ id: generateTempId() }])
                          : newData
                      )
                    } else if (text == "remove") {
                      const flag =
                        GZData.findIndex((d) => d.id === t.id) ===
                        GZData.length - 1
                      if (flag) {
                        setGZData(
                          GZData.map((item: any) => {
                            if (item.id == t.id) {
                              return { id: generateTempId() }
                            } else {
                              return item
                            }
                          })
                        )
                      } else {
                        setGZData(GZData.filter((item: any) => item.id != t.id))
                      }
                    }
                  })}
                  sticky
                />
              </>
            )}
          </Form>
          <Form
            form={formStepSecond}
            labelCol={{ span: 8 }}
            wrapperCol={{ span: 16 }}
            style={{ paddingRight: 10 }}
            onFinish={(vs) => {
              if (CSData?.length <= 1) {
                notification.error({
                  message: "请添加从事专业工作经历",
                })
                return
              }
              setStepSecondData(vs)
              setStep(step + 1)
              if (scrollDivRef.current) {
                scrollDivRef.current.scrollTop = 0
              }
            }}
          >
            {step === 1 && (
              <>
                <Row style={{ fontSize: 17, fontWeight: "bold" }}>
                  指导老师基本信息
                </Row>
                <Row
                  style={{
                    fontSize: 14,
                    fontWeight: "bold",
                    marginTop: 15,
                    marginBottom: 10,
                  }}
                >
                  人员基本信息
                </Row>
                <Row>
                  <Col span={12}>
                    <Form.Item
                      name="name"
                      label="姓名"
                      rules={[{ required: true }]}
                    >
                      <Input allowClear />
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item
                      name="sex"
                      label="性别"
                      rules={[{ required: true }]}
                    >
                      <Select allowClear>
                        {types.systemUserSex?.map((v: any) => {
                          return (
                            <Option key={v.value} value={v.value}>
                              {v.label}
                            </Option>
                          )
                        })}
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item
                      name="cardType"
                      label="证件类型"
                      rules={[{ required: true }]}
                    >
                      <Select allowClear>
                        {types.idCardType?.map((v: any) => {
                          return (
                            <Option key={v.value} value={v.value}>
                              {v.label}
                            </Option>
                          )
                        })}
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item
                      name="cardNo"
                      label="证件号码"
                      rules={[{ required: true }]}
                    >
                      <Input allowClear />
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item
                      name="education"
                      label="学历"
                      rules={[{ required: true }]}
                    >
                      <Select allowClear>
                        {types.educationLevel?.map((v: any) => {
                          return (
                            <Option key={v.value} value={v.value}>
                              {v.label}
                            </Option>
                          )
                        })}
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item
                      name="degree"
                      label="学位"
                      rules={[{ required: true }]}
                    >
                      <Select allowClear>
                        {types.degreeType?.map((v: any) => {
                          return (
                            <Option key={v.value} value={v.value}>
                              {v.label}
                            </Option>
                          )
                        })}
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item
                      name="professionalTitle"
                      label="职称"
                      rules={[{ required: true }]}
                    >
                      <Input allowClear />
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item
                      name="professionalMajor"
                      label="职称证书专业"
                      rules={[{ required: true }]}
                    >
                      <Input allowClear />
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item
                      name="professionalOrg"
                      label="主要执业机构"
                      rules={[{ required: true }]}
                    >
                      <Input allowClear />
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item
                      name="department"
                      label="所在科室"
                      rules={[{ required: true }]}
                    >
                      <Input allowClear />
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item name="multiPointOrg" label="多点执业机构">
                      <Input allowClear />
                    </Form.Item>
                  </Col>
                  <Col span={12} className={styles.formItemAddonAfter}>
                    <Form.Item
                      name="workYears"
                      label="工作年限"
                      rules={[{ required: true }]}
                    >
                      <Input
                        addonAfter={<div style={{ width: "100%" }}>年</div>}
                        allowClear
                      />
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item
                      name="qualificationCertificateNumber"
                      label="医师资格证书编号"
                      rules={[{ required: true }]}
                    >
                      <Input allowClear />
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item
                      labelCol={{ span: 8 }}
                      wrapperCol={{ span: 16 }}
                      name="qualificationCertificateFile"
                      label="医师资格证书"
                      rules={[{ required: true, message: "请上传医师资格证书" }]}
                    >
                      <Row align="middle">
                        <>
                          <Upload
                            customRequest={(options) =>
                              customRequestFn(options, "ZG")
                            }
                            beforeUpload={(file) =>
                              beforeUpload(file, fileZGUrl)
                            }
                            showUploadList={false}
                            maxCount={3}
                            accept={acceptImgTypes}
                          >
                            <Button icon={<PlusOutlined />}>上传</Button>
                          </Upload>
                        </>
                        {fileZGUrl?.length > 0 &&
                          fileZGUrl?.map((v: any, index: number) => {
                            return (
                              <div
                                key={index}
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  cursor: "pointer",
                                  paddingLeft: 10,
                                }}
                              >
                                <span style={{ paddingRight: 10 }}>
                                  {v.fileName}{" "}
                                  <a
                                    style={{ paddingLeft: 10 }}
                                    onClick={() => setPreviewFile(v)}
                                  >
                                    查看
                                  </a>
                                </span>
                                <CloseOutlined
                                  style={{
                                    position: "relative",
                                    top: 2,
                                    color: "rgb(161 161 161)",
                                  }}
                                  onClick={() => {
                                    handleRemove("ZG", index)
                                  }}
                                />
                              </div>
                            )
                          })}
                      </Row>
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item
                      name="practiceCertificateNumber"
                      label="医师执业证书编号"
                      rules={[{ required: true }]}
                    >
                      <Input allowClear />
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item
                      labelCol={{ span: 8 }}
                      wrapperCol={{ span: 16 }}
                      name="practiceCertificateFile"
                      label="医师执业证书"
                      rules={[{ required: true, message: "请上传医师执业证书" }]}
                    >
                      <Row align="middle">
                        <>
                          <Upload
                            customRequest={(options) =>
                              customRequestFn(options, "ZY")
                            }
                            beforeUpload={(file) =>
                              beforeUpload(file, fileZYUrl)
                            }
                            showUploadList={false}
                            maxCount={3}
                            accept={acceptImgTypes}
                          >
                            <Button icon={<PlusOutlined />}>上传</Button>
                          </Upload>
                        </>
                        {fileZYUrl?.length > 0 &&
                          fileZYUrl?.map((v: any, index: number) => {
                            return (
                              <div
                                key={index}
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  cursor: "pointer",
                                  paddingLeft: 10,
                                }}
                              >
                                <span style={{ paddingRight: 10 }}>
                                  {v.fileName}{" "}
                                  <a
                                    style={{ paddingLeft: 10 }}
                                    onClick={() => setPreviewFile(v)}
                                  >
                                    查看
                                  </a>
                                </span>
                                <CloseOutlined
                                  style={{
                                    position: "relative",
                                    top: 2,
                                    color: "rgb(161 161 161)",
                                  }}
                                  onClick={() => {
                                    handleRemove("ZY", index)
                                  }}
                                />
                              </div>
                            )
                          })}
                      </Row>
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item
                      name="telNumber"
                      label="联系电话"
                      rules={[{ required: true }]}
                    >
                      <Input allowClear />
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item
                      name="address"
                      label="通讯地址"
                      rules={[{ required: true }]}
                    >
                      <Input allowClear />
                    </Form.Item>
                  </Col>
                  <Col span={24}>
                    <Form.Item
                      labelCol={{ span: 16 }}
                      wrapperCol={{ span: 8 }}
                      name="advancedCertificateFile"
                      label="副高以上职称证书或经核准其执业的卫生行政部门出具的从事中医临床工作15年以上证明"
                      rules={[{ required: true, message: "请上传副高以上职称证书或经核准其执业的卫生行政部门出具的从事中医临床工作15年以上证明" }]}
                    >
                      <Row align="middle">
                        <>
                          <Upload
                            customRequest={(options) =>
                              customRequestFn(options, "FG")
                            }
                            beforeUpload={(file) =>
                              beforeUpload(file, fileFGUrl)
                            }
                            showUploadList={false}
                            maxCount={3}
                            accept={acceptImgTypes}
                          >
                            <Button icon={<PlusOutlined />}>上传</Button>
                          </Upload>
                        </>
                        {fileFGUrl?.length > 0 &&
                          fileFGUrl?.map((v: any, index: number) => {
                            return (
                              <div
                                key={index}
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  cursor: "pointer",
                                  paddingLeft: 10,
                                }}
                              >
                                <span style={{ paddingRight: 10 }}>
                                  {v.fileName}{" "}
                                  <a
                                    style={{ paddingLeft: 10 }}
                                    onClick={() => setPreviewFile(v)}
                                  >
                                    查看
                                  </a>
                                </span>
                                <CloseOutlined
                                  style={{
                                    position: "relative",
                                    top: 2,
                                    color: "rgb(161 161 161)",
                                  }}
                                  onClick={() => {
                                    handleRemove("FG", index)
                                  }}
                                />
                              </div>
                            )
                          })}
                      </Row>
                    </Form.Item>
                  </Col>
                </Row>
                <Row
                  style={{
                    fontSize: 14,
                    fontWeight: "bold",
                    marginTop: 15,
                    marginBottom: 10,
                  }}
                >
                  从事专业工作经历
                </Row>
                <EditableList
                  style={{ marginTop: "15px" }}
                  scroll={{ x: "30rem" }}
                  dataSource={CSData}
                  pagination={false}
                  rowKey={(m: any) => m.id}
                  columns={CTYXEngagedColumns((text, t) => {
                    if (text == "edit") {
                      const result = validateRequiredFields(t, CSRequiredList)
                      const flag =
                        CSData.findIndex((d) => d.id === t.id) ===
                        CSData.length - 1
                      const newData = CSData.map((item: any) => {
                        if (item.id == t.id) {
                          return t
                        } else {
                          return item
                        }
                      })

                      setCSData(
                        result
                          ? newData
                          : flag //判断是否为最新一行，是的就添加一行
                          ? newData.concat([{ id: generateTempId() }])
                          : newData
                      )
                    } else if (text == "remove") {
                      const flag =
                        CSData.findIndex((d) => d.id === t.id) ===
                        CSData.length - 1
                      if (flag) {
                        setCSData(
                          CSData.map((item: any) => {
                            if (item.id == t.id) {
                              return { id: generateTempId() }
                            } else {
                              return item
                            }
                          })
                        )
                      } else {
                        setCSData(CSData.filter((item: any) => item.id != t.id))
                      }
                    }
                  })}
                  sticky
                />
              </>
            )}
          </Form>
          <Form
            form={formStepThird}
            labelCol={{ span: 6 }}
            wrapperCol={{ span: 18 }}
            style={{ paddingRight: 10 }}
            onFinish={(vs) => {
              setStepThirdData(vs)
              setSubmitVisible(true)
              if (scrollDivRef.current) {
                scrollDivRef.current.scrollTop = 0
              }
            }}
          >
            {step === 3 && (
              <>
                <Row style={{ fontSize: 17, fontWeight: "bold" }}>
                  跟师学习情况
                </Row>
                <Row>
                  <Col span={24}>
                    <Form.Item
                      name="contractNotarizationDate"
                      label="合同公证时间"
                      rules={[{ required: true }]}
                    >
                      <DatePicker
                        style={{ width: "100%" }}
                        format={DateTimeFormatSimpleOnly}
                        allowClear
                      />
                    </Form.Item>
                  </Col>
                  <Col span={24}>
                    <Form.Item
                      name="learningDate"
                      label="公证合同的跟师学习时间"
                      rules={[{ required: true }]}
                    >
                      <RangePicker
                        style={{ width: "100%" }}
                        format={DateTimeFormatSimpleOnly}
                        allowClear
                      />
                    </Form.Item>
                  </Col>
                  <Col span={24}>
                    <Form.Item
                      name="healthCommissionName"
                      label="合同备案卫健委名称"
                      rules={[{ required: true }]}
                    >
                      <Input allowClear />
                    </Form.Item>
                  </Col>
                  <Col span={24}>
                    <Form.Item
                      name="learningClassHours"
                      label="跟师学习的学时数"
                      rules={[{ required: true }]}
                    >
                      <Input allowClear />
                    </Form.Item>
                  </Col>
                  <Col span={24}>
                    <Form.Item
                      name="learningOrgName"
                      label="跟师学习医疗机构名称"
                      rules={[{ required: true }]}
                    >
                      <Input allowClear />
                    </Form.Item>
                  </Col>
                  <Col span={24}>
                    <Form.Item
                      name="learningOrgDept"
                      label="跟师学习科室"
                      rules={[{ required: true }]}
                    >
                      <Input allowClear />
                    </Form.Item>
                  </Col>
                  <Col span={24}>
                    <Form.Item
                      name="learningOrgAddress"
                      label="跟师学习医疗机构地址"
                      rules={[{ required: true }]}
                    >
                      <Input allowClear />
                    </Form.Item>
                  </Col>
                  {/* <Col span={24}>
                    <Form.Item
                      name="firstApprenticeshipAssessmentYear"
                      label="首次参加全省出师考核年度"
                    >
                      <Input allowClear />
                    </Form.Item>
                  </Col> */}
                  {/* <Col span={24}>
                    <Form.Item
                      name="lastYearAssessmentStatus"
                      label="上一年度临床实践技能考核情况"
                    >
                      <Select allowClear>
                        {types.assessmentStatus?.map((v: any) => {
                          return (
                            <Option key={v.value} value={v.value}>
                              {v.label}
                            </Option>
                          )
                        })}
                      </Select>
                    </Form.Item>
                  </Col> */}
                  {/* <Col span={24}>
                    <Form.Item
                      name="masterApprenticeContractFile"
                      label="传统医学师承关系合同书"
                      rules={[{ required: true, message: "请上传传统医学师承关系合同书" }]}
                    >
                      <Row align="middle">
                        <>
                          <Upload
                            customRequest={(options) =>
                              customRequestFn(options, "HT")
                            }
                            beforeUpload={(file) =>
                              beforeUploadFileAndImage(file, fileHTUrl)
                            }
                            showUploadList={false}
                            maxCount={3}
                            accept={".pdf,.jpg,.jpeg,.png,.gif"}
                          >
                            <Button icon={<PlusOutlined />}>上传</Button>
                          </Upload>
                          <span style={{ padding: "0 0px 0 15px" }}>
                            文件格式为加盖公章的pdf版和图片上传
                          </span>
                        </>
                        {fileHTUrl?.length > 0 &&
                          fileHTUrl?.map((v: any, index: number) => {
                            return (
                              <div
                                key={index}
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  cursor: "pointer",
                                  paddingLeft: 10,
                                }}
                              >
                                <span style={{ paddingRight: 10 }}>
                                  {v.fileName}{" "}
                                  <a
                                    style={{ paddingLeft: 10 }}
                                    onClick={() => setPreviewFile(v)}
                                  >
                                    查看
                                  </a>
                                </span>
                                <CloseOutlined
                                  style={{
                                    position: "relative",
                                    top: 2,
                                    color: "rgb(161 161 161)",
                                  }}
                                  onClick={() => {
                                    handleRemove("HT", index)
                                  }}
                                />
                              </div>
                            )
                          })}
                      </Row>
                    </Form.Item>
                  </Col> */}
                  {props.filingType == 6 && <Col span={24}>
                    <Form.Item
                      name="clinicalPracticeFile"
                      label="临床实践协议书"
                      rules={[{ required: true, message: "请上传临床实践协议书" }]}
                    >
                      <Row align="middle">
                        <>
                          <Upload
                            customRequest={(options) =>
                              customRequestFn(options, "SJ")
                            }
                            beforeUpload={(file) =>
                              beforeUploadFileAndImage(file, fileGZUrl)
                            }
                            showUploadList={false}
                            maxCount={3}
                            accept={".pdf,.jpg,.jpeg,.png,.gif"}
                          >
                            <Button icon={<PlusOutlined />}>上传</Button>
                          </Upload>
                          <span style={{ padding: "0 0px 0 15px" }}>
                            支持pdf和图片文件格式上传
                          </span>
                        </>
                        {fileSJUrl?.length > 0 &&
                          fileSJUrl?.map((v: any, index: number) => {
                            return (
                              <div
                                key={index}
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  cursor: "pointer",
                                  paddingLeft: 10,
                                }}
                              >
                                <span style={{ paddingRight: 10 }}>
                                  {v.fileName}{" "}
                                  <a
                                    style={{ paddingLeft: 10 }}
                                    onClick={() => setPreviewFile(v)}
                                  >
                                    查看
                                  </a>
                                </span>
                                <CloseOutlined
                                  style={{
                                    position: "relative",
                                    top: 2,
                                    color: "rgb(161 161 161)",
                                  }}
                                  onClick={() => {
                                    handleRemove("SJ", index)
                                  }}
                                />
                              </div>
                            )
                          })}
                      </Row>
                    </Form.Item>
                  </Col>}
                  <Col span={24}>
                    <Form.Item
                      name="notarizedCertificateFile"
                      label="公证书"
                      rules={[{ required: true, message: "请上传公证书" }]}
                    >
                      <Row align="middle">
                        <>
                          <Upload
                            customRequest={(options) =>
                              customRequestFn(options, "GZ")
                            }
                            beforeUpload={(file) =>
                              beforeUploadFileAndImage(file, fileGZUrl)
                            }
                            showUploadList={false}
                            maxCount={3}
                            accept={".pdf,.jpg,.jpeg,.png,.gif"}
                          >
                            <Button icon={<PlusOutlined />}>上传</Button>
                          </Upload>
                          <span style={{ padding: "0 0px 0 15px" }}>
                            文件格式为加盖公章的pdf版
                          </span>
                        </>
                        {fileGZUrl?.length > 0 &&
                          fileGZUrl?.map((v: any, index: number) => {
                            return (
                              <div
                                key={index}
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  cursor: "pointer",
                                  paddingLeft: 10,
                                }}
                              >
                                <span style={{ paddingRight: 10 }}>
                                  {v.fileName}{" "}
                                  <a
                                    style={{ paddingLeft: 10 }}
                                    onClick={() => setPreviewFile(v)}
                                  >
                                    查看
                                  </a>
                                </span>
                                <CloseOutlined
                                  style={{
                                    position: "relative",
                                    top: 2,
                                    color: "rgb(161 161 161)",
                                  }}
                                  onClick={() => {
                                    handleRemove("GZ", index)
                                  }}
                                />
                              </div>
                            )
                          })}
                      </Row>
                    </Form.Item>
                  </Col>
                </Row>
              </>
            )}
          </Form>
        </div>
        <Row justify="end" style={{ marginTop: 20 }}>
          <Space>
            <Button onClick={props.onCancel}>取消</Button>
            {step > 1 && (
              <Button
                type="primary"
                ghost
                onClick={() => {
                  if (step === 2) {
                    setStepFirstData(formStepFirst.getFieldsValue())
                  } else {
                    setStepThirdData(formStepThird.getFieldsValue())
                  }
                  setStep(step - 1)
                }}
              >
                上一步
              </Button>
            )}
            {step < 3 && (
              <Button
                type="primary"
                onClick={() => {
                  if (step === 1) {
                    formStepSecond.submit()
                  } else {
                    formStepFirst.submit()
                  }
                }}
              >
                下一步
              </Button>
            )}
            {step === 3 && (
              <Button type="primary" onClick={formStepThird.submit}>
                提交
              </Button>
            )}
          </Space>
        </Row>
      </Modal>

      <Modal
        title="提交申请"
        width={450}
        visible={submitVisible}
        onCancel={() => setSubmitVisible(false)}
        confirmLoading={confirmLoading}
        onOk={() => {
          setConfirmLoading(true)
          const data = {
            applicantUserId: credentials.userId,
            applicantUserName: credentials.userName,
            id: props.againId,
            memo: props.memo,
            filingType: props.filingType,
            filingApplicantPersonDTO: {
              ...stepFirstData,
              birthDate: moment(stepFirstData.birthDate).format(DateTimeFormatSimpleOnly),
              filingStudyExperienceDTOList: XXData?.slice(0, -1)?.map((d: any) => {
                return {
                  ...d,
                  id: null,
                  startTime: moment(d.startTime).format('YYYY-MM'),
                  endTime: moment(d.endTime).format('YYYY-MM'),
                }
              }),
              filingWorkExperienceDTOList: GZData?.slice(0, -1)?.map((d: any) => {
                return {
                  ...d,
                  id: null,
                  studyStartDate: moment(d.studyStartDate).format('YYYY-MM'),
                  studyEndDate: moment(d.studyEndDate).format('YYYY-MM'),
                }
              }),
            },
            filingGuidanceTeacherDTO: {
              ...stepSecondData,
              filingWorkExperienceDTOList: CSData?.slice(0, -1)?.map((d: any) => {
                return {
                  ...d,
                  id: null,
                  studyStartDate: moment(d.studyStartDate).format('YYYY-MM'),
                  studyEndDate: moment(d.studyEndDate).format('YYYY-MM'),
                }
              }),
            },
            filingFollowLearningDTO: {
              ...stepThirdData,
              contractNotarizationDate: moment(stepThirdData.contractNotarizationDate).format(DateTimeFormatSimpleOnly),
              learningStartDate: moment(stepThirdData.learningDate?.[0]).format(DateTimeFormatSimpleOnly),
              learningEndDate: moment(stepThirdData.learningDate?.[1]).format(DateTimeFormatSimpleOnly),
              learningDate: undefined
            },
          }
          axios({
            url: `${AXIOS_IP}/filingReviewMentor/saveOrUpdate`,
            headers: {
              "Content-Type": "application/json",
              "His-Auth": props.token,
            },
            withCredentials: false,
            method: "POST",
            data,
          })
            .then((res) => {
              if (res.data?.data || res.data?.success) {
                setSubmitVisible(false)
                notification.success({
                  message: "操作成功",
                })
                props.onOk()
              } else {
                notification.error({
                  message: res.data?.msg || "操作失败，请稍后重试",
                })
              }
            })
            .catch(() => {
              notification.error({
                message: "请求异常，请稍后重试",
              })
            })
            .finally(() => {
              setConfirmLoading(false)
            })
        }}
        okText="确认提交"
        centered
        maskClosable={false}
      >
        <Row style={{ height: 50 }}>
          提交后请耐心等待工作人员审核
        </Row>
      </Modal>

      <PreviewImgOrPdf
        token={props.token}
        AXIOS_IP={AXIOS_IP}
        file={previewFile}
        onClose={() => setPreviewFile(null)}
      />
    </>
  )
}
